import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NbToastrService, NbGlobalPhysicalPosition, NbDialogService } from '@nebular/theme';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { InternalSearchService } from '../internal-search.service';
import { OrganizationUnitService } from '../../organization-unit/organization-unit.service';
import { DepartamentService } from '../../departament/departament.service';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { AddQuestionComponent } from '../../../../@theme/components/add-question/add-question.component';
import { LocalDataSource } from 'ng2-smart-table';
import { v4 as uuidv4 } from 'uuid';
import { time } from 'console';
import { Duration } from 'ngx-bootstrap/chronos/duration/constructor';
import { ResultImportComponent } from '../../result-import/result-import.component';
import { UserService } from '../../user/user.service';
import { TypeHiringUserService } from '../../type-hiring-user/type-hiring-user.service';


@Component({
  selector: 'ngx-show-internal-search',
  templateUrl: 'show-internal-search.component.html',
  styleUrls: ['show-internal-search.component.scss'],
})
export class ShowInternalSearchComponent implements OnInit {

  public internalSearch: any = {};
  public parentId = '';
  dropdownSettings = {};

  public notPermitedChange = false;

  registerForm: FormGroup;
  submitted = false;
  public questionTypes: any[] = [];
  questionTypeSelected: any[];
  controlCheck = false;

  departaments: any = [];
  unities: any = [];

  departamentSelected;
  unitySelected;
  typeContracts;
  dropdownSettingsDepartamens = {};
  dropdownSettingsUnity = {};
  typeUserSelected;
  dateRange;
  questions;
  cols: any[];
  source: LocalDataSource = new LocalDataSource();

  usersSel: any[] = [];
  users: any[] = [];


  @ViewChild('item', { static: false }) accordion;

  settings = {
    actions: {
      columnTitle: 'Ações',
    },
    add: {
      addButtonContent: '<i class="nb-plus"></i>',
      createButtonContent: '<i class="nb-checkmark"></i>',
      cancelButtonContent: '<i class="nb-close"></i>',
    },
    edit: {
      editButtonContent: '<i class="nb-edit"></i>',
      saveButtonContent: '<i class="nb-checkmark"></i>',
      cancelButtonContent: '<i class="nb-close"></i>',
    },
    delete: {
      deleteButtonContent: '<i class="nb-trash"></i>',
    },
    mode: 'external',
    columns: {
      title: {
        title: 'Título',
        type: 'string',
      },
      typeResponse: {
        title: 'Tipo da questão',
        type: 'string',
        filter: false,
        valuePrepareFunction: (value) => {
          if (value === 'BOX_TEXT') {
            return 'Caixa de texto';
          } else if (value === 'SINGLE_SELECTION') {
            return 'Resposta única';
          } else if (value === 'MULTI_SELECTION') {
            return 'Múltipla escolha';
          } else if (value === 'STAR') {
            return 'Estrelas';
          } else if (value === 'ZERO_TEN') {
            return '0 a 10';
          }
        },
      },
      isRequired: {
        title: 'Obrigatória',
        type: 'string',
        filter: false,
        valuePrepareFunction: (value) => {
          if (value) {
            return 'Sim';
          } else {
            return 'Não';
          }
        },
      }
    },
    noDataMessage: 'Nenhum registro encontrado',
  };


  constructor(private internalSearchService: InternalSearchService, private route: ActivatedRoute,
    private unityService: OrganizationUnitService, private departamentService: DepartamentService,
    private toastrService: NbToastrService, private router: Router, private formBuilder: FormBuilder,
    private localeService: BsLocaleService, private dialogService: NbDialogService,
    private typeHiringService: TypeHiringUserService,
    private userService: UserService) {
    this.localeService.use('pt-br');
    this.parentId = this.route.snapshot.params.parentId;

    const isClone = this.route.snapshot.queryParams.isClone;

    this.searchUser();

    if (isClone) {
      this.getClone(this.parentId);
    } else {
      this.get(this.parentId);
    }

    this.getAllDepartaments();
    this.getAllUnities();
    this.getTypeContract();

    this.cols = [
      { field: 'title', header: 'Título' },
      { field: 'typeResponse', header: 'Tipo de resposta' }
    ];
  }

  searchUser() {

    const obj: any = {};

    if (this.departamentSelected != null) {
      if (this.departamentSelected.length > 0) {
        obj.departamentIds = this.departamentSelected.map(a => a.id);
      } else {
        obj.departamentIds = [];
      }
    }
    if (this.typeUserSelected != null) {
      if (this.typeUserSelected.length > 0) {
        obj.typesHiringIds = this.typeUserSelected.map(a => a.id);
      } else {
        obj.typesHiringIds = [];
      }
    }

    if (this.unitySelected != null) {
      if (this.unitySelected.length > 0) {
        obj.unityIds = this.unitySelected.map(a => a.id);
      } else {
        obj.unityIds = [];
      }
    }
    this.users = [];
    obj.isShowLogged = true;
    this.userService.search(obj).toPromise().then(result => {
      this.users = result;
      for (let h = 0; h < this.usersSel.length; h++) {
        const element = this.usersSel[h];
        for (let b = 0; b < this.users.length; b++) {
          const u = this.users[b];
          if (element.id === u.id) {
            this.users.splice(b, 1);
          }
        }
      }
    });
  }

  getAllDepartaments() {
    this.departamentService.query().toPromise().then(result => {
      this.departaments = result.body;
    }).catch(err => {
      this.toastrService.show('Pesquisa', err.error.title,
        { position: NbGlobalPhysicalPosition.TOP_RIGHT, status: 'success' });
    });
  }

  getTypeContract() {
    this.typeContracts = [];

    this.typeHiringService.query().toPromise().then(result => {
      this.typeContracts = result.body;
    })

    // this.typeContracts.push({ id: 1, title: 'PJ' });
    // this.typeContracts.push({ id: 2, title: 'CLT' });
  }

  getAllUnities() {
    this.unityService.query().toPromise().then(result => {
      this.unities = result.body;
    }).catch(err => {
      this.toastrService.show('Pesquisa', err.error.title,
        { position: NbGlobalPhysicalPosition.TOP_RIGHT, status: 'success' });
    });
  }

  ngOnInit() {
    this.registerForm = this.formBuilder.group({
      name: ['', Validators.required],
    });

    this.dropdownSettings = {
      singleSelection: true,
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      idField: 'id',
      textField: 'title',
      searchPlaceholderText: 'Localizar',
      allowSearchFilter: true
    };

    this.dropdownSettingsDepartamens = {
      idField: "id",
      textField: "description",
      singleSelection: false,
      selectAllText: "Selecionar tudo",
      searchPlaceholderText: "Localizar",
      itemsShowLimit: 2,
      unSelectAllText: "Deselecionar Tudo",
      allowSearchFilter: true,
      noDataAvailablePlaceholderText: "Nenhum registro encontrado",
    };

    this.dropdownSettingsUnity = {
      idField: "id",
      textField: "name",
      singleSelection: false,
      selectAllText: "Selecionar tudo",
      searchPlaceholderText: "Localizar",
      unSelectAllText: "Deselecionar Tudo",
      itemsShowLimit: 2,
      allowSearchFilter: true,
      noDataAvailablePlaceholderText: "Nenhum registro encontrado",
    };

    this.questionTypes = [
      {
        id: 'BOX_TEXT',
        title: 'Caixa de texto'
      },
      {
        id: 'SINGLE_SELECTION',
        title: 'Resposta unica'
      },
      {
        id: 'MULTI_SELECTION',
        title: 'Múltipla escolha'
      }
    ];
  }

  onSubmit() {
    this.submitted = true;

    if (this.registerForm.invalid) {
      return;
    }

    this.save();
  }

  toggle() {
    this.internalSearch.actived = !this.internalSearch.actived;
  }

  getClone(parentId) {
    this.internalSearchService.findClone(parentId).toPromise().then(response => {
      this.internalSearch = response.body;
      if (!this.internalSearch.config) {
        this.internalSearch.config = {};
        this.dateRange = [new Date(), new Date()];
      } else {

        if (this.internalSearch.config.initDate) {
          this.dateRange = [new Date(this.internalSearch.config.initDate),
          new Date(this.internalSearch.config.endDate)];
        }

        setTimeout(() => {
          this.departamentSelected = [];
          for (let i = 0; i < this.departaments.length; i++) {
            const departament = this.departaments[i];
            for (let j = 0; j < this.internalSearch.config.departaments.length; j++) {
              const obj = this.internalSearch.config.departaments[j];
              if (obj === departament.id) {
                this.departamentSelected.push(departament);
              }
            }
          }

          this.unitySelected = [];
          for (let i = 0; i < this.unities.length; i++) {
            const unity = this.unities[i];
            for (let j = 0; j < this.internalSearch.config.unities.length; j++) {
              const obj = this.internalSearch.config.unities[j];
              if (obj === unity.id) {
                this.unitySelected.push(unity);
              }
            }
          }

          this.usersSel = [];
          for (let j = 0; j < this.internalSearch.config.usersObj.length; j++) {
            const obj = this.internalSearch.config.usersObj[j];
            this.usersSel.push(obj);
          }

          for (let h = 0; h < this.usersSel.length; h++) {
            const element = this.usersSel[h];
            for (let b = 0; b < this.users.length; b++) {
              const u = this.users[b];
              if (element.id === u.id) {
                this.users.splice(b, 1);
              }
            }
          }


          this.typeUserSelected = [];
          if (this.internalSearch.config.typeUser) {
            for (let x = 0; x < this.typeContracts.length; x++) {
              const type = this.typeContracts[x];
              if (this.internalSearch.config.typeUser === type.title) {
                this.typeUserSelected.push(type);
              }
            }
          }
        }, 500);
      }
      this.internalSearch.questions.sort((a, b) => a.order - b.order);
      for (let i = 0; i < this.internalSearch.questions.length; i++) {
        const question = this.internalSearch.questions[i];
        question.id = uuidv4();
        question.responses.sort((a, b) => a.order - b.order);
      }

      this.source.load(this.internalSearch.questions);


      this.controlCheck = this.internalSearch.actived;
    }).catch(err => {
      this.toastrService.show('Pesquisa', err.error.title,
        { position: NbGlobalPhysicalPosition.TOP_RIGHT, status: 'success' });
    });
  }

  get(parentId) {
    if (parentId === 'create') {
      this.internalSearch = {};
      this.internalSearch.weightAll = 0;
      this.internalSearch.config = {};
      this.internalSearch.actived = false;
      this.internalSearch.hasAverage = false;
      this.internalSearch.isAnonymous = false;
      this.controlCheck = false;
      this.questionTypeSelected = [];
    } else {
      this.internalSearchService.find(this.parentId).toPromise().then(response => {
        this.internalSearch = response.body;
        if (this.internalSearch.status === 'RUNNING' || this.internalSearch.status === 'FINISH') {
          this.notPermitedChange = true;
        }

        if (!this.internalSearch.config) {
          this.internalSearch.config = {};
          this.dateRange = [new Date(), new Date()];
        } else {

          if (this.internalSearch.config.initDate) {
            this.dateRange = [new Date(this.internalSearch.config.initDate),
            new Date(this.internalSearch.config.endDate)];
          }

          setTimeout(() => {
            this.departamentSelected = [];
            for (let i = 0; i < this.departaments.length; i++) {
              const departament = this.departaments[i];
              for (let j = 0; j < this.internalSearch.config.departaments.length; j++) {
                const obj = this.internalSearch.config.departaments[j];
                if (obj === departament.id) {
                  this.departamentSelected.push(departament);
                }
              }
            }

            this.unitySelected = [];
            for (let i = 0; i < this.unities.length; i++) {
              const unity = this.unities[i];
              for (let j = 0; j < this.internalSearch.config.unities.length; j++) {
                const obj = this.internalSearch.config.unities[j];
                if (obj === unity.id) {
                  this.unitySelected.push(unity);
                }
              }
            }

            this.usersSel = [];
            for (let j = 0; j < this.internalSearch.config.usersObj.length; j++) {
              const obj = this.internalSearch.config.usersObj[j];
              this.usersSel.push(obj);
            }

            for (let h = 0; h < this.usersSel.length; h++) {
              const element = this.usersSel[h];
              for (let b = 0; b < this.users.length; b++) {
                const u = this.users[b];
                if (element.id === u.id) {
                  this.users.splice(b, 1);
                }
              }
            }

            this.typeUserSelected = [];
            if (this.internalSearch.config.typeUser) {
              for (let x = 0; x < this.typeContracts.length; x++) {
                const type = this.typeContracts[x];
                if (this.internalSearch.config.typeUser === type.title) {
                  this.typeUserSelected.push(type);
                }
              }
            }
          }, 500);
        }
        this.internalSearch.questions.sort((a, b) => a.order - b.order);
        for (let i = 0; i < this.internalSearch.questions.length; i++) {
          const question = this.internalSearch.questions[i];
          question.responses.sort((a, b) => a.order - b.order);
        }

        this.source.load(this.internalSearch.questions);


        this.controlCheck = this.internalSearch.actived;
      }).catch(err => {
        this.toastrService.show('Pesquisa', err.error.title,
          { position: NbGlobalPhysicalPosition.TOP_RIGHT, status: 'success' });
      });
    }
  }

  removeQuestion(index: number) {
    this.internalSearch.questions.splice(index, 1);
    this.accordion.closeAll();
    this.toastrService.show('Pesquisa', `Questão ${index + 1} excluida com sucesso!`,
      { position: NbGlobalPhysicalPosition.TOP_RIGHT, status: 'success' });
  }

  disabled(listReponse, index, question) {
    if (question.typeResponse === 'SINGLE_SELECTION') {
      for (let i = 0; i < listReponse.length; i++) {
        const reponse = listReponse[i];
        if (i !== index) {
          reponse.correct = false;
        }
      }
    }
  }

  modelChanged(event) {
    const dateRange = event;
    if (dateRange) {
      this.internalSearch.config.initDate = dateRange[0];
      this.internalSearch.config.endDate = dateRange[1];
    } else {
      this.internalSearch.config.initDate = null;
      this.internalSearch.config.endDate = null;
    }

  }

  openCreateDialog() {
    this.openQuestionDialog({});
  }

  openEditDialog(event): void {
    this.openQuestionDialog(event.data);
  }

  private validQuestionNps(): boolean {
    if (this.internalSearch.questions && this.internalSearch.questions.length > 0) {
      for (let i = 0; i < this.internalSearch.questions.length; i++) {
        const question = this.internalSearch.questions[i];
        if (question.isUseNpsMetrics) {
          return true;
        }
      }
    }
    return false;
  }

  openQuestionDialog(objectQuestion) {
    this.dialogService.open(AddQuestionComponent, {
      context: {
        title: 'Adicionar questão',
        objectQuestion: objectQuestion,
        hasMedia: this.internalSearch.hasAverage,
        hasNpsOtherQuestion: this.validQuestionNps(),
        notPermitedChange: this.notPermitedChange,
      },
    }).onClose.subscribe(response => {
      if (response) {
        if (response.id) {
          for (let i = 0; i < this.internalSearch.questions.length; i++) {
            const question = this.internalSearch.questions[i];
            if (question.id === response.id) {
              this.internalSearch.questions[i] = response;
            }
          }
        } else {
          if (!this.internalSearch.questions) {
            this.internalSearch.questions = [];
          }
          response.id = uuidv4();
          this.internalSearch.questions.push(response);
        }
        if (response.hasCorrectQuestion) {
          this.internalSearch.weightAll = 0;
          for (let i = 0; i < this.internalSearch.questions.length; i++) {
            const question = this.internalSearch.questions[i];
            if (question.hasCorrectQuestion) {
              this.internalSearch.weightAll = this.internalSearch.weightAll + question.weight;
            }
          }
        }

        this.source.load(this.internalSearch.questions);
      }

    });
  }

  onDeleteConfirm(event) {
    if (!this.notPermitedChange) {
      for (let i = 0; i < this.internalSearch.questions.length; i++) {
        const element = this.internalSearch.questions[i];
        if (element.title === event.data.title) {
          this.internalSearch.questions.splice(i, 1);
        }
      }
      this.source.load(this.internalSearch.questions);
    }

  }

  addResponse(internalSearchQuestion, newOrder) {
    internalSearchQuestion.responses.push({ correct: false, order: newOrder });
  }

  removeResponse(index: number, internalSearchQuestion) {
    internalSearchQuestion.responses.splice(index, 1);
  }

  addQuestion() {
    this.accordion.closeAll();
    this.internalSearch.questions.push({
      typeResponse: 'BOX_TEXT', order: this.internalSearch.questions.length,
      responses: [{ title: null, order: 0 }],
    });
  }

  goBack() {
    this.router.navigate(['pages/admin/internal-search']);
  }

  save() {
    if (!this.internalSearch) {
      return;
    }

    if (this.internalSearch.hasAverage) {
      if (this.internalSearch.weightAll != 100) {
        this.toastrService.danger('Pesquisa', 'O total dos pesos das questões que possuem alternativas corretas deve ser igual a 100.  Peso total atual:' + this.internalSearch.weightAll,
          { position: NbGlobalPhysicalPosition.TOP_RIGHT, status: 'danger', duration: 5000 });
        return;
      }
    }

    if (this.usersSel != null) {
      if (this.usersSel.length > 0) {
        this.internalSearch.config.users = this.usersSel.map(a => a.id);
      } else {
        this.internalSearch.config.users = [];
      }
    }

    if (this.users != null) {
      if (this.users.length > 0) {
        this.internalSearch.config.usersNotSel = this.users.map(a => a.id);
      } else {
        this.internalSearch.config.usersNotSel = [];
      }
    }

    if (this.internalSearch.questions) {
      if (!this.internalSearch.hasAverage) {
        for (let i = 0; i < this.internalSearch.questions.length; i++) {
          const element = this.internalSearch.questions[i];
          element.weight = null;
          element.order = i;
        }
      } else {
        for (let i = 0; i < this.internalSearch.questions.length; i++) {
          const element = this.internalSearch.questions[i];
          element.order = i;
        }
      }
    }
    if (this.internalSearch.id) {
      this.internalSearchService.update(this.internalSearch).toPromise().then(response => {
        this.toastrService.show('Pesquisa', 'Salvo com sucesso',
          { position: NbGlobalPhysicalPosition.TOP_RIGHT, status: 'success' });
        this.goBack();
      }).catch(err => {
        this.toastrService.show('Pesquisa', err.error.title,
          { position: NbGlobalPhysicalPosition.TOP_RIGHT, status: 'danger', duration: 7000 });
      });
    } else {
      this.internalSearchService.create(this.internalSearch).toPromise().then(response => {
        this.toastrService.show('Pesquisa', 'Salvo com sucesso',
          { position: NbGlobalPhysicalPosition.TOP_RIGHT, status: 'success' });
        this.goBack();
      }).catch(err => {
        this.toastrService.show('Pesquisa', err.error.title,
          { position: NbGlobalPhysicalPosition.TOP_RIGHT, status: 'danger', duration: 7000 });
      });
    }
  }

}
